import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";
import "./allDriver.css";
import "../style01.css";
import "../style02.css";
import img1 from "../../../assets/images/img1_metuaa_green.svg";
import img2 from "../../../assets/images/img2_metuaa_green.svg";
import img3 from "../../../assets/images/img3_metuaa_green.svg";
import img4 from "../../../assets/images/img4_metuaa_green.svg";
import img5 from "../../../assets/images/img5_metuaa_green.svg";
import onboardingStep1 from "../../../assets/images/app_6.png";
import onboardingStep2 from "../../../assets/images/app_7.png";
import onboardingStep3 from "../../../assets/images/inspection.jpg";
import onboardingStep4 from "../../../assets/images/conference.jpg";
import onboardingStep5 from "../../../assets/images/activation.jpg";
import driverRewardsPhoto from "../../../assets/images/app_8.png";
import driverHeroPhoto from "../../../assets/images/driverreplacement.jpg";
import driverRestPhoto1 from "../../../assets/images/blackdriverman.jpg";
import driverTestimonialAvatar from "../../../assets/images/avatar.png";
import safetyPhoto from "../../../assets/images/f4.png";
import economyCar from "../../../assets/images/classique.png";
import standardCar from "../../../assets/images/premium.png";
import priorityCar from "../../../assets/images/gold.png";
import Header from "../../../components/header";
import Footer from "../../../components/footer";


function DriverStepIcon({ kind }) {
  if (kind === "document") {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path d="M6 3h9l3 3v15H6V3zm8 1.5V7h2.5L14 4.5zM8 11h8v1.5H8V11zm0 3h8v1.5H8V14z" />
      </svg>
    );
  }

  if (kind === "vehicle") {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path d="M5 14l1.2-4.2A2 2 0 0 1 8.1 8.3h7.8a2 2 0 0 1 1.9 1.4L19 14v3h-1.5v1.5H16V17H8v1.5H6.5V17H5v-3zm2.2-.8h9.6l-.7-2.3H7.9l-.7 2.3z" />
      </svg>
    );
  }

  if (kind === "training") {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path d="M12 4 3.5 8.5 12 13l7-3.7V15h1.5V8.5L12 4zm-6.5 9v2.4L12 19l6.5-3.6V13L12 16.5 5.5 13z" />
      </svg>
    );
  }

  if (kind === "account") {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path d="M12 3a9 9 0 1 0 9 9 9.01 9.01 0 0 0-9-9zm0 4.2a2.7 2.7 0 1 1 0 5.4 2.7 2.7 0 0 1 0-5.4zm0 12.2a6.7 6.7 0 0 1-5.2-2.5c.06-1.8 3.5-2.8 5.2-2.8s5.1 1 5.2 2.8A6.7 6.7 0 0 1 12 19.4z" />
      </svg>
    );
  }

  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M12 3a9 9 0 1 0 9 9 9 9 0 0 0-9-9zm1 9.4 3.2 2-1 1.6-4.2-2.6V6h2v6.4z" />
    </svg>
  );
}

function DriverStepRow({ step, title, description, image, alt, icon }) {
  return (
    <article className="driver-step-row">
      <div className="driver-step-media">
        <img className="driver-image" src={image} alt={alt} loading="lazy" decoding="async" />
      </div>

      <div className="driver-step-content">
        <div className="driver-step-marker" aria-hidden="true">
          <span className="driver-step-marker-inner">
            <DriverStepIcon kind={icon} />
          </span>
        </div>

        <div className="driver-step-copy">
          <span className="driver-step-number">{step}</span>
          <div className="driver-step-text">
            <h3>{title}</h3>
            <p>{description}</p>
          </div>
        </div>
      </div>
    </article>
  );
}

function DriverStepsSection() {
  const intl = useIntl();
  const t = (id) => intl.formatMessage({ id });

  return (
    <section className="section section-soft driver-steps-section">
      <div className="page-shell driver-steps-shell">
        <header className="driver-steps-header">
          <h2>{t("driver.steps.title")}</h2>
          <p>{t("driver.steps.subtitle")}</p>
        </header>

        <div className="driver-steps-list" role="list" aria-label={t("driver.steps.ariaLabel")}>
          {driverSteps.map((step) => (
            <DriverStepRow
              key={step.step}
              step={step.step}
              title={t(step.titleId)}
              description={t(step.descriptionId)}
              image={step.image}
              alt={t(step.altId)}
              icon={step.icon}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

function AppleIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M15.8 2.4c-.8.1-1.7.6-2.2 1.3-.5.7-.8 1.6-.7 2.5.8.1 1.7-.4 2.3-1.1.6-.7 1-1.7.6-2.7zM12 7c1.4 0 2.3.8 3.4.8 1.1 0 1.9-.8 3.3-.8 1.2 0 2.7.7 3.5 1.8-1.1.7-2 2.1-2 4 0 2.2 1.5 4.1 2.5 4.7-.7 1.8-2.2 4.1-4.1 4.1-1.1 0-1.6-.7-3-.7s-2 .7-3 .7c-1.9 0-3.6-2.1-4.4-3.9C6 16.9 5 14.9 5 12.6 5 9.3 7 7 9.7 7c1.3 0 2.1.8 2.3.8.2 0 1.2-.8 2.4-.8z" />
    </svg>
  );
}

function PlayIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M3.5 2.9 13.8 12 3.5 21.1V2.9z" />
      <path d="M14.6 11.2 18.9 8.8c1.5-.8 3.1-.2 3.1 1.2 0 .7-.4 1.2-1 1.6l-3.8 2.1-2.6-2.5z" />
      <path d="M14.6 12.8l2.6 2.5 3.8 2.1c.6.3 1 .9 1 1.6 0 1.4-1.6 2-3.1 1.2l-4.3-2.4-1.6-1.5 1.6-1.5z" />
    </svg>
  );
}

function ArrowLeftIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M14.8 4.8 13.4 3.4 5 11.8l8.4 8.4 1.4-1.4-6-6H21v-2H8.8l6-6z" />
    </svg>
  );
}

function ArrowRightIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="m9.2 19.2 1.4 1.4 8.4-8.4-8.4-8.4-1.4 1.4 6 6H3v2h12.2l-6 6z" />
    </svg>
  );
}

function ClockIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm1 10.4 3.2 2-1 1.6-4.2-2.6V6h2v6.4z" />
    </svg>
  );
}

function BoltIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M14 2 5 13h6l-1 9 9-11h-6l1-9z" />
    </svg>
  );
}

function LockIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M17 9h-1V7a4 4 0 0 0-8 0v2H7a2 2 0 0 0-2 2v9h14v-9a2 2 0 0 0-2-2zm-6 0V7a1 1 0 0 1 2 0v2h-2z" />
    </svg>
  );
}

function SparkIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M12 2.5 9.7 8.3 3.9 10.6l5.8 2.3L12 18.7l2.3-5.8 5.8-2.3-5.8-2.3L12 2.5z" />
    </svg>
  );
}

function ExternalArrowIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M13 5h6v6h-2V8.4l-8.7 8.7-1.4-1.4L15.6 7H13V5z" />
    </svg>
  );
}

function EnterpriseFeatureIcon({ kind }) {
  if (kind === "shield") {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path d="M12 2 4 5v6c0 5.2 3.5 9.8 8 11 4.5-1.2 8-5.8 8-11V5l-8-3zm-1 13.6-3.2-3.2 1.4-1.4L11 12.8l3.8-3.8 1.4 1.4-5.2 5.2z" />
      </svg>
    );
  }

  if (kind === "card") {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path d="M3 5h18v14H3V5zm2 3v2h14V8H5zm0 5h6v2H5v-2z" />
      </svg>
    );
  }

  if (kind === "users") {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path d="M16 11a4 4 0 1 0-4-4 4 4 0 0 0 4 4zM8 12a3 3 0 1 0-3-3 3 3 0 0 0 3 3zm0 2c-2.7 0-5 1.8-5 4v2h10v-2c0-2.2-2.3-4-5-4zm8 0c-.6 0-1.2.1-1.7.3 1 .8 1.7 2 1.7 3.7v2h6v-2c0-2.2-2.3-4-6-4z" />
      </svg>
    );
  }

  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M4 19h16v2H4v-2zM7 5h3v12H7V5zm7 4h3v8h-3V9zm-3-6h3v14h-3V3z" />
    </svg>
  );
}

const rideCards = [
  {
    id: "economy",
    labelId: "rider.rides.label1",
    titleId: "home.carousel.card1.title",
    image: economyCar,
    icon: ClockIcon,
    points: [
      { icon: ClockIcon, textId: "rider.rides.economy.point1" },
      { icon: LockIcon, textId: "rider.rides.economy.point2" },
    ],
  },
  {
    id: "standard",
    labelId: "rider.rides.label2",
    titleId: "home.carousel.card2.title",
    image: standardCar,
    icon: BoltIcon,
    points: [
      { icon: BoltIcon, textId: "rider.rides.standard.point1" },
      { icon: LockIcon, textId: "rider.rides.standard.point2" },
    ],
  },
  {
    id: "priority",
    labelId: "rider.rides.label3",
    titleId: "rider.rides.priority.title",
    image: priorityCar,
    icon: SparkIcon,
    points: [
      { icon: BoltIcon, textId: "rider.rides.priority.point1" },
      { icon: LockIcon, textId: "rider.rides.priority.point2" },
    ],
  },
];


const driverSteps = [
  {
    step: "01",
    titleId: "driver.step1.title",
    descriptionId: "driver.step1.description",
    image: onboardingStep1,
    altId: "driver.step1.alt",
    icon: "user",
  },
  {
    step: "02",
    titleId: "driver.step2.title",
    descriptionId: "driver.step2.description",
    image: onboardingStep2,
    altId: "driver.step2.alt",
    icon: "document",
  },
  {
    step: "03",
    titleId: "driver.step3.title",
    descriptionId: "driver.step3.description",
    image: onboardingStep3,
    altId: "driver.step3.alt",
    icon: "vehicle",
  },
  {
    step: "04",
    titleId: "driver.step4.title",
    descriptionId: "driver.step4.description",
    image: onboardingStep4,
    altId: "driver.step4.alt",
    icon: "training",
  },
  {
    step: "05",
    titleId: "driver.step5.title",
    descriptionId: "driver.step5.description",
    image: onboardingStep5,
    altId: "driver.step5.alt",
    icon: "account",
  },
];

function StoreBadge({ href, label, sublabel, Icon }) {
  return (
    <a className="store-badge" href={href} target="_blank" rel="noreferrer" aria-label={label}>
      <span className="store-badge-icon" aria-hidden="true">
        <Icon />
      </span>
      <span className="store-badge-copy">
        <span>{sublabel}</span>
        <strong>{label}</strong>
      </span>
    </a>
  );
}

function SplitSection({ className = "", reversed = false, title, text, image, imageAlt, children, cta, link, eyebrow }) {
  return (
    <section className={`section ${className}`}>
      <div className="page-shell">
        <div className={`split-layout ${reversed ? "reverse" : ""}`}>
          <div className="split-copy">
            {eyebrow ? <p className="eyebrow">{eyebrow}</p> : null}
            <h2 className="section-title">{title}</h2>
            <p className="section-copy">{text}</p>
            {cta ? <div className="section-actions">{cta}</div> : null}
            {link ? <div className="section-link-wrap">{link}</div> : null}
          </div>
          <div className="split-media">
            {image ? <img className="section-photo" src={image} alt={imageAlt} loading="lazy" decoding="async" /> : null}
            {children}
          </div>
        </div>
      </div>
    </section>
  );
}

// --- Icônes SVG ---------------------------------------------------------------

const IconLanguage = () => (
  <svg width="24" height="24" viewBox="0 0 32 32" style={{ fill: "currentColor" }} aria-hidden="true" focusable="false">
    <path d="M15.982 3C8.719 3 4.05 7.7 4.05 14.932c0 3.662 1.16 6.683 3.357 8.82L5.973 29l6.469-2.533c1.13.275 2.35.427 3.57.427 7.263 0 11.932-4.7 11.932-11.932S23.244 3 15.982 3zm0 22.308c-1.251 0-2.624-1.923-3.387-5.036h6.774c-.763 3.113-2.136 5.036-3.387 5.036zm-3.693-6.653a23.424 23.424 0 0 1-.274-3.723c0-1.343.091-2.594.274-3.723h7.385c.184 1.129.275 2.38.275 3.723s-.091 2.594-.275 3.723H12.29zm3.693-14.038c1.251 0 2.624 1.923 3.387 5.036h-6.774c.762-3.113 2.136-5.036 3.387-5.036zm5.31 6.622h4.516c.336 1.068.519 2.32.519 3.723 0 1.404-.183 2.625-.519 3.723h-4.516c.152-1.16.244-2.41.244-3.723 0-1.312-.061-2.563-.244-3.723zm3.875-1.586h-4.15c-.427-1.892-1.068-3.48-1.861-4.639 2.472.61 4.73 2.075 6.011 4.639zM12.808 5.014c-.793 1.16-1.434 2.747-1.861 4.639h-4.15c1.281-2.564 3.54-4.029 6.011-4.639zM6.156 11.24h4.516a28.605 28.605 0 0 0 0 7.446H6.156a13.066 13.066 0 0 1-.52-3.723c0-1.403.184-2.655.52-3.723zm6.164 13.55-3.998 1.556.855-3.113-.366-.335a8.99 8.99 0 0 1-2.015-2.625h4.15c.428 1.892 1.069 3.48 1.862 4.639-.091-.03-.152-.03-.244-.061l-.244-.061zm6.836.122c.793-1.16 1.434-2.747 1.861-4.639h4.15c-1.281 2.533-3.54 3.998-6.011 4.639z" />
  </svg>
);

const IconHamburger = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" style={{ fill: "currentColor" }} aria-hidden="true" focusable="false">
    <path d="M29 7.75H3v1.989h26V7.75zm0 7.26H3V17h26v-1.99zm0 7.238H3v1.989h26v-1.99z" />
  </svg>
);

const IconArrowRight = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" style={{ fill: "currentColor" }} aria-hidden="true" focusable="false">
    <path d="M9.652 2.65 8.426 3.876l3.258 3.258H1v1.728h10.684L8.426 12.12l1.226 1.226L15 7.998 9.652 2.65z" />
  </svg>
);

const IconArrowLeft = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" style={{ fill: "currentColor" }} aria-hidden="true" focusable="false">
    <path d="m12.843 25.836 1.585-1.608L7.32 17.12H29v-2.256H7.321l7.107-7.13-1.585-1.585L3 15.993l9.843 9.843z" />
  </svg>
);

const IconArrowRightLg = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" style={{ fill: "currentColor" }} aria-hidden="true" focusable="false">
    <path d="m19.157 6.15-1.584 1.608 7.106 7.107H3v2.256h21.679l-7.106 7.13 1.584 1.585L29 15.993 19.157 6.15z" />
  </svg>
);

const IconChevronDown = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" style={{ fill: "currentColor" }} aria-hidden="true" focusable="false">
    <path d="M7.988 12.11 1 5.098 2.208 3.89l5.78 5.78 5.78-5.78L15 5.098 7.988 12.11z" />
  </svg>
);

const IconPickup = () => (
  <svg width="24" height="24" viewBox="0 0 32 32" style={{ fill: "currentColor" }} aria-hidden="true" focusable="false">
    <path d="M4.8 25.6h5.9V29h1.7v-5.1H4.8v1.7zM17.5 8C18.9 8 20 6.9 20 5.5S18.9 3 17.5 3 15 4.1 15 5.5 16.1 8 17.5 8z" />
    <path d="M25.3 5.4s-.6 1.2-2.5 2.6c-1.1.8-2.6 1.3-4 1.3h-2.7c-2.2 0-4.2 1.2-5.3 3.1-1.4 2.6-1.9 4.3-1.9 4.4l2.1.5s.4-1.6 1.7-3.9c.4-.7 1-1.3 1.8-1.6V29h2.1v-9.8h1.9V29h2.1V11.2c1.2-.3 2.4-.7 3.4-1.5 2.4-1.7 3.1-3.2 3.2-3.4l-1.9-.9z" />
  </svg>
);

const IconCalendarScheduled = () => (
  <svg width="24" height="24" viewBox="0 0 32 32" style={{ fill: "currentColor" }} aria-hidden="true" focusable="false">
    <path d="M24.119 5.69V3h-1.594v2.69H9.475V3H7.881v2.69H6.287C4.494 5.69 3 7.084 3 8.977V29h22.713C27.506 29 29 27.506 29 25.713V5.69h-4.881zM6.287 7.284h1.594v2.49h1.594v-2.49h13.05v2.49h1.594v-2.49h3.287v4.682H4.594V8.977c0-.996.797-1.693 1.693-1.693zm19.426 20.122H4.593V13.46h22.813v12.153c0 .996-.797 1.793-1.693 1.793z" />
    <path d="M24.119 20.732h-4.383v4.383h4.383v-4.383z" />
  </svg>
);

const IconPromos = () => (
  <svg width="24" height="24" viewBox="0 0 32 32" style={{ fill: "currentColor" }} aria-hidden="true" focusable="false">
    <path d="m9.431 19.428-.7-1.259-.7 1.26a8.737 8.737 0 0 1-3.442 3.47l-1.259.671 1.26.7a8.807 8.807 0 0 1 3.47 3.47l.7 1.26.7-1.26a8.807 8.807 0 0 1 3.47-3.47l1.259-.7-1.26-.7a8.631 8.631 0 0 1-3.498-3.442zm-.7 6.465A9.922 9.922 0 0 0 6.438 23.6a9.923 9.923 0 0 0 2.295-2.295 9.926 9.926 0 0 0 2.294 2.295 9.924 9.924 0 0 0-2.294 2.294zm.672-14.805a9.978 9.978 0 0 1 4.03-4.03A10.221 10.221 0 0 1 9.403 3c-.923 1.707-2.35 3.107-4.058 4.058a10.22 10.22 0 0 1 4.058 4.03zm18.22 3.667a19.02 19.02 0 0 1-7.585-7.585l-.7-1.26-.7 1.26a18.674 18.674 0 0 1-7.584 7.585l-1.259.7 1.26.699a19.019 19.019 0 0 1 7.584 7.584l.7 1.26.7-1.26a18.675 18.675 0 0 1 7.584-7.584l1.26-.7-1.26-.7zm-8.284 7.052a20.54 20.54 0 0 0-6.353-6.353 20.541 20.541 0 0 0 6.353-6.353 20.544 20.544 0 0 0 6.353 6.353 20.846 20.846 0 0 0-6.353 6.353z" />
  </svg>
);

const IconRocket = () => (
  <svg width="24" height="24" viewBox="0 0 32 32" style={{ fill: "currentColor" }} aria-hidden="true" focusable="false">
    <path d="M28.926 3.087S28.14 3 26.943 3c-2.31 0-6.144.327-8.606 2.179a44.097 44.097 0 0 0-6.165 6.732l-.109.152c-.043.044-.065.087-.109.13H9.471a4.119 4.119 0 0 0-2.963 1.243L3 16.965l5.86 1.09 5.033 5.054 1.09 5.882 3.485-3.551a4.209 4.209 0 0 0 1.198-2.941v-2.375a46.317 46.317 0 0 0 7.081-6.47c2.876-3.704 2.179-10.567 2.179-10.567zM6.268 15.963l1.372-1.394a2.627 2.627 0 0 1 1.83-.763h1.373L8.97 16.464l-2.701-.501zm11.808 6.58c0 .675-.261 1.328-.74 1.808l-1.33 1.35-.5-2.636 2.57-1.808v1.285zm7.43-9.892a44.837 44.837 0 0 1-6.34 5.86l-4.489 3.16-4.335-4.38 3.006-4.27a42.042 42.042 0 0 1 6.013-6.579c2.114-1.59 5.665-1.83 7.582-1.83h.458c.043 2.244-.284 5.926-1.896 8.04z" />
    <path d="M23 8.926a2.19 2.19 0 0 0-1.133-.588 2.26 2.26 0 0 0-1.264.13 2.258 2.258 0 0 0-1.35 2.048c0 .436.13.872.37 1.22.24.37.588.654.98.828a2.1 2.1 0 0 0 1.264.13A2.19 2.19 0 0 0 23 12.108l-.087.109c.24-.196.414-.458.566-.741.13-.283.196-.588.218-.893 0-.305-.044-.632-.174-.915A2.866 2.866 0 0 0 23 8.926zM9.427 25.483a9.863 9.863 0 0 1-3.18.37 9.373 9.373 0 0 1 .544-3.725 6.359 6.359 0 0 1 1.481-2.287l-1.83-.349a7.56 7.56 0 0 0-1.176 2.07 11 11 0 0 0-.567 5.098l.066.61.61.087c.457.065.936.087 1.394.087 1.024 0 2.07-.152 3.072-.435a7.986 7.986 0 0 0 2.767-1.438l-.349-1.852c-.697.828-1.7 1.438-2.832 1.764z" />
  </svg>
);

const IconCoupon = () => (
  <svg width="24" height="24" viewBox="0 0 32 32" style={{ fill: "currentColor" }} aria-hidden="true" focusable="false">
    <path d="m28.33 11.98-3.446-2.45-1.27-4.05-4.233.06L15.995 3 12.61 5.54l-4.232-.06-1.27 4.05-3.477 2.45L4.99 16l-1.36 4.02 3.477 2.45 1.27 4.05 4.232-.06L15.995 29l3.386-2.54 4.233.06 1.27-4.05 3.476-2.45L27 16l1.33-4.02zm-1.905 7.406-2.932 2.056-1.058 3.416-3.598-.03-2.872 2.146-2.872-2.146-3.598.03-1.058-3.416-2.933-2.056L6.654 16l-1.15-3.386 2.933-2.056 1.058-3.416 3.598.03 2.902-2.177 2.872 2.147 3.598-.03 1.058 3.416 2.933 2.056-1.15 3.386 1.12 3.416z" />
    <path d="M19.656 10.884 10.89 19.65l1.41 1.411 8.766-8.765-1.411-1.41zm-6.684 3.696c.877 0 1.602-.726 1.602-1.603s-.725-1.603-1.602-1.603c-.877 0-1.602.726-1.602 1.603s.695 1.602 1.602 1.602zm6.046 2.81c-.876 0-1.602.726-1.602 1.603s.726 1.602 1.602 1.602c.877 0 1.603-.725 1.603-1.602 0-.877-.726-1.602-1.603-1.602z" />
  </svg>
);

const IconGrinningFace = () => (
  <svg width="24" height="24" viewBox="0 0 32 32" style={{ fill: "currentColor" }} aria-hidden="true" focusable="false">
    <path d="M16 3C8.8 3 3 8.8 3 16s5.8 13 13 13 13-5.8 13-13S23.2 3 16 3zm0 24.4C9.7 27.4 4.6 22.3 4.6 16 4.6 9.7 9.7 4.6 16 4.6c6.3 0 11.4 5.1 11.4 11.4 0 6.3-5.1 11.4-11.4 11.4z" />
    <path d="M10.4 18.7c.6 2.6 2.9 4.4 5.6 4.4 2.7 0 4.9-1.8 5.6-4.4l.2-1H10.2l.2 1zm10.8-6.9c-1.3 0-2.4 1.2-2.4 2.7h1.6c0-.6.4-1.1.8-1.1s.8.5.8 1.1h1.6c0-1.5-1.1-2.7-2.4-2.7zm-10.4 1.6c.4 0 .8.5.8 1.1h1.6c0-1.5-1.1-2.7-2.4-2.7-1.3 0-2.4 1.2-2.4 2.7H10c0-.6.4-1.1.8-1.1z" />
  </svg>
);

const IconTwitter = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" style={{ fill: "currentColor" }} aria-hidden="true" focusable="false">
    <path d="M5.403 13.376c5.283 0 8.172-4.377 8.172-8.173 0-.124 0-.248-.008-.371A5.844 5.844 0 0 0 15 3.345a5.732 5.732 0 0 1-1.65.452 2.882 2.882 0 0 0 1.263-1.589c-.564.335-1.18.57-1.824.697a2.875 2.875 0 0 0-4.895 2.62 8.155 8.155 0 0 1-5.92-3 2.874 2.874 0 0 0 .89 3.833 2.85 2.85 0 0 1-1.304-.36v.037c0 1.368.964 2.545 2.304 2.816a2.868 2.868 0 0 1-1.297.05 2.876 2.876 0 0 0 2.684 1.994A5.763 5.763 0 0 1 1 12.085a8.132 8.132 0 0 0 4.403 1.289" />
  </svg>
);

const IconFacebook = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" style={{ fill: "currentColor" }} aria-hidden="true" focusable="false">
    <path d="M15 8a7 7 0 1 0-8.094 6.915v-4.892H5.13V8h1.777V6.458c0-1.755 1.045-2.724 2.644-2.724.766 0 1.567.137 1.567.137v1.723h-.883c-.87 0-1.14.54-1.14 1.093V8h1.941l-.31 2.023H9.094v4.892A7.002 7.002 0 0 0 15 8z" clipRule="evenodd" fillRule="evenodd" />
  </svg>
);

const IconInstagram = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" style={{ fill: "currentColor" }} aria-hidden="true" focusable="false">
    <path d="M7.998 4.918a3.08 3.08 0 1 0 0 6.16 3.08 3.08 0 0 0 0-6.16zm0 5.08a2 2 0 1 1 0-4 2 2 0 0 1 0 4z" clipRule="evenodd" fillRule="evenodd" />
    <path d="M11.2 5.516a.72.72 0 1 0 0-1.44.72.72 0 0 0 0 1.44z" />
    <path d="M7.998 2c-1.629 0-1.833.007-2.473.036-.638.03-1.074.13-1.456.279a2.94 2.94 0 0 0-1.062.692 2.94 2.94 0 0 0-.692 1.062c-.148.382-.25.818-.279 1.456-.03.64-.036.844-.036 2.473 0 1.63.007 1.833.036 2.473.03.639.13 1.075.279 1.456.153.395.358.729.692 1.063.333.333.668.538 1.062.691.382.149.818.25 1.456.28.64.028.844.035 2.473.035 1.63 0 1.833-.007 2.473-.036.639-.029 1.075-.13 1.456-.279a2.939 2.939 0 0 0 1.063-.691c.333-.334.538-.668.691-1.063.149-.381.25-.817.28-1.456.028-.64.035-.844.035-2.473s-.007-1.833-.036-2.473c-.029-.638-.13-1.074-.279-1.456a2.939 2.939 0 0 0-.691-1.062 2.94 2.94 0 0 0-1.063-.692c-.381-.148-.817-.25-1.456-.279C9.831 2.006 9.627 2 7.998 2zm0 1.08c1.602 0 1.791.007 2.424.036.585.026.902.124 1.114.206.28.11.48.239.69.449.21.21.34.41.448.69.082.211.18.529.207 1.113.028.633.034.823.034 2.424 0 1.602-.006 1.791-.034 2.424-.027.585-.125.902-.207 1.114-.109.28-.239.48-.449.69-.21.21-.41.34-.69.448-.21.082-.528.18-1.113.207-.633.028-.822.034-2.424.034-1.602 0-1.791-.006-2.424-.034-.584-.027-.902-.125-1.113-.207a1.858 1.858 0 0 1-.69-.449c-.21-.21-.34-.41-.449-.69-.082-.21-.18-.528-.206-1.113-.03-.633-.035-.822-.035-2.424 0-1.601.006-1.791.035-2.424.026-.584.124-.902.206-1.113.11-.28.239-.48.449-.69.21-.21.41-.34.69-.449.211-.082.529-.18 1.113-.206.633-.03.823-.035 2.424-.035z" clipRule="evenodd" fillRule="evenodd" />
  </svg>
);

// Icônes carrousel
const IconDollar = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" style={{ fill: "currentColor" }} aria-hidden="true" focusable="false">
    <path d="M8 1C4.155 1 1 4.1 1 8s3.155 7 7 7 7-3.1 7-7c-.099-3.9-3.254-7-7-7zm2.86 9.1c-.297.7-.987 1.4-2.268 1.6v.9H7.31v-.9c-1.085-.2-1.775-.6-2.07-1l.985-.8c.198.2.79.6 1.972.6.888 0 1.38-.4 1.48-.8.098-.3 0-.5-.1-.7-.394-.3-1.084-.4-1.774-.5-.888-.1-1.676-.2-2.268-.7-.591-.5-.69-1.4-.394-2.1.296-.9 1.183-1.4 2.267-1.5v-.9h1.184v.9c1.084.2 1.676.6 2.07 1l-.986.8c-.296-.2-.789-.6-1.972-.6-.789 0-1.281.3-1.479.7-.098.3-.098.6.099.7.296.3.986.3 1.577.4.888.1 1.775.2 2.465.8.592.6.789 1.4.493 2.1z" />
  </svg>
);

const IconValet = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" style={{ fill: "currentColor" }} aria-hidden="true" focusable="false">
    <path d="M7.577 4.308c1.271.293 2.347-.783 2.054-2.054a1.624 1.624 0 0 0-1.206-1.206A1.704 1.704 0 0 0 6.37 3.1c.13.587.62 1.076 1.206 1.207zm2.445 1.336c-.424-.13-1.434-.26-2.021-.26-.62 0-1.597.162-2.054.293-.945.26-1.662 1.075-2.347 4.27h1.271c.49-2.184.946-2.803 1.24-3.032L6.663 15h2.478l.75-8.117c.293.163.75.717 1.271 3.032h1.239c-.685-3.163-1.402-3.978-2.38-4.27z" />
  </svg>
);

const IconLightning = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" style={{ fill: "currentColor" }} aria-hidden="true" focusable="false">
    <path d="M12.4 6.7H8.9V1L3.6 9.3h3.5V15l5.3-8.3z" />
  </svg>
);

const IconCar = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" style={{ fill: "currentColor" }} aria-hidden="true" focusable="false">
    <path d="M14.95 9.686c.056-.693.076-1.4 0-1.808-.207-1.013-.606-1.398-1.03-1.804l-.3-.297h1.04v-.996h-1.55l-.58-1.61a2.27 2.27 0 0 0-1.938-1.333c-3.195-.192-5.13 0-5.218 0a2.35 2.35 0 0 0-1.927 1.368l-.564 1.577H1.33v.996h1.037l-.337.332c-.418.39-.848.789-.995 1.797-.052.63-.046 1.263.02 1.892v.022c.042.544.102 1.078.157 1.49l.22 1.995a.988.988 0 0 0 .987.946h.7a.99.99 0 0 0 .989-.99v-.63c.988.034 2.286.064 3.879.064s2.892-.03 3.879-.065v.63a.991.991 0 0 0 .99.99h.699a.981.981 0 0 0 .986-.909l.243-2.16c.052-.376.12-.92.165-1.486l.002-.01zM5.854 8.73a.83.83 0 0 1-.825.797H3.742a.787.787 0 0 1-.788-.797.815.815 0 0 1 .788-.789h1.325a.788.788 0 0 1 .786.789zm7.17 0a.84.84 0 0 1-.837.797h-1.281a.787.787 0 0 1-.788-.797.815.815 0 0 1 .788-.789h1.325a.787.787 0 0 1 .792.789zM4.356 3.583a1.354 1.354 0 0 1 1.103-.752c.018 0 1.944-.184 5.052 0a1.26 1.26 0 0 1 1.076.714l.788 2.183a37.75 37.75 0 0 1-4.396.197 37.602 37.602 0 0 1-4.435-.201l.812-2.14z" />
  </svg>
);

const IconStar = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" style={{ fill: "currentColor" }} aria-hidden="true" focusable="false">
    <path d="M14.556 7.543a1.08 1.08 0 0 0-.632-1.951h-2.961a1.077 1.077 0 0 1-1.024-.743l-.914-2.815a1.08 1.08 0 0 0-2.05 0L6.06 4.85a1.082 1.082 0 0 1-1.027.743H2.076a1.08 1.08 0 0 0-.632 1.951l2.393 1.739a1.076 1.076 0 0 1 .391 1.203l-.913 2.816a1.08 1.08 0 0 0 1.656 1.206l2.393-1.74a1.074 1.074 0 0 1 1.267 0l2.393 1.74A1.079 1.079 0 0 0 12.68 13.3l-.914-2.816a1.076 1.076 0 0 1 .392-1.203l2.398-1.739z" />
  </svg>
);

const IconFamily = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" style={{ fill: "currentColor" }} aria-hidden="true" focusable="false">
    <path d="M4.301 5.473c.948 0 1.712-.764 1.712-1.711 0-.948-.764-1.712-1.712-1.712a1.71 1.71 0 0 0-1.712 1.712 1.71 1.71 0 0 0 1.712 1.711zm7.428 0a1.71 1.71 0 0 0 1.712-1.711 1.71 1.71 0 0 0-1.712-1.712c-.948 0-1.712.764-1.712 1.712 0 .947.764 1.711 1.712 1.711zM8 9.294c-1.865 0-2.63.795-2.63 2.69v1.956h5.228v-1.956c0-1.895-.825-2.69-2.598-2.69zm0-1.07c.856 0 1.528-.672 1.528-1.528S8.856 5.168 8 5.168s-1.53.672-1.53 1.528S7.144 8.224 8 8.224zM5.463 6.696v-.092c-.337-.091-.734-.122-1.162-.122C1.947 6.482 1 7.491 1 9.875v2.904h3.118v-.795c0-2.109.886-3.148 1.987-3.607a2.495 2.495 0 0 1-.642-1.68zm6.266-.214c-.459 0-.856.061-1.223.122v.092a2.51 2.51 0 0 1-.672 1.712c1.283.55 1.986 1.773 1.986 3.576v.795H15V9.875c.03-2.384-1.01-3.393-3.271-3.393z" />
  </svg>
);

const IconPrivacyChoice = () => (
  <svg height="12px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 14">
    <g fillRule="evenodd" clipRule="evenodd" fill="#fff">
      <path d="M7.4 12.8h6.8l3.1-11.6H7.4C4.2 1.2 1.6 3.8 1.6 7s2.6 5.8 5.8 5.8z" />
    </g>
    <g fillRule="evenodd" clipRule="evenodd" fill="#06f">
      <path d="M22.6 0H7.4c-3.9 0-7 3.1-7 7s3.1 7 7 7h15.2c3.9 0 7-3.1 7-7s-3.2-7-7-7zm-21 7c0-3.2 2.6-5.8 5.8-5.8h9.9l-3.1 11.6H7.4c-3.2 0-5.8-2.6-5.8-5.8z" />
    </g>
    <g fill="#fff">
      <path d="M24.6 4c.2.2.2.6 0 .8L22.5 7l2.2 2.2c.2.2.2.6 0 .8-.2.2-.6.2-.8 0l-2.2-2.2-2.2 2.2c-.2.2-.6.2-.8 0-.2-.2-.2-.6 0-.8L20.8 7l-2.2-2.2c-.2-.2-.2-.6 0-.8.2-.2.6-.2.8 0l2.2 2.2L23.8 4c.2-.2.6-.2.8 0z" />
    </g>
    <g fill="#06f">
      <path d="M12.7 4.1c.2.2.3.6.1.8L8.6 9.8c-.1.1-.2.2-.3.2-.2.1-.5.1-.7-.1L5.4 7.7c-.2-.2-.2-.6 0-.8.2-.2.6-.2.8 0L8 8.6l3.8-4.5c.2-.2.6-.2.9 0z" />
    </g>
  </svg>
);

// --- Données carrousel ---------------------------------------------------------

const carouselCards = [
  {
    labelId: "home.carousel.card1.label",
    titleId: "home.carousel.card1.title",
    img: img1,
    descIcons: [<IconDollar />, <IconValet />],
    descTextIds: ["home.carousel.card1.desc1", "home.carousel.card1.desc2"],
  },
  {
    labelId: "home.carousel.card2.label",
    titleId: "home.carousel.card2.title",
    img: img2,
    descIcons: [<IconLightning />, <IconValet />],
    descTextIds: ["home.carousel.card2.desc1", "home.carousel.card2.desc2"],
  },
  {
    labelId: "home.carousel.card3.label",
    titleId: "home.carousel.card3.title",
    img: img3,
    descIcons: [<IconLightning />, <IconValet />],
    descTextIds: ["home.carousel.card3.desc1", "home.carousel.card3.desc2"],
  },
  {
    labelId: "home.carousel.card4.label",
    titleId: "home.carousel.card4.title",
    img: img4,
    descIcons: [<IconCar />, <IconStar />],
    descTextIds: ["home.carousel.card4.desc1", "home.carousel.card4.desc2"],
  },
  {
    labelId: "home.carousel.card5.label",
    titleId: "home.carousel.card5.title",
    img: img5,
    descIcons: [<IconCar />, <IconFamily />],
    descTextIds: ["home.carousel.card5.desc1", "home.carousel.card5.desc2"],
  },
];

// --- Données footer ------------------------------------------------------------

const footerDriverLinks = [
  { href: "https://www.lyft.com/drive-with-lyft", text: "Devenir chauffeur" },
  { href: "https://www.lyft.com/driver/new-driver-guide", text: "Guide du nouveau chauffeur" },
  { href: "/driver/pay", text: "Recettes" },
  { href: "/driver/cities", text: "Villes" },
  { href: "https://www.lyft.com/click/dax-help-center", text: "Aide" },
  { href: "/driver/safety", text: "Sécurité" },
  { href: "/driver-application-requirements", text: "Exigences de candidature" },
  { href: "/expressdrive", text: "Conduite Express" },
  { href: "/driver/bonus", text: "Prime" },
  { href: "/driver/rewards", text: "Récompenses Metua'a" },
  { href: "/driver/insurance", text: "Assurance" },
  { href: "/black-car-fleet", text: "Flottes de voitures Noires" },
  { href: "/hub", text: "Blogue du chauffeur" },
  { href: "/driver/beta", text: "Programme bêta" },
];

const footerRiderLinks = [
  { href: "/rider", text: "Inscrivez-vous" },
  { href: "https://www.lyft.com/memberships/lyft-pink-all-access-annual/offer-details", text: "Metua'a Pink" },
  { href: "/rider/cities", text: "Villes" },
  { href: "https://www.lyft.com/click/pax-help-center", text: "Aide" },
  { href: "/rider/safety", text: "Sécurité" },
  { href: "/rider/business", text: "Profil professionnel" },
  { href: "/rider/rewards", text: "Récompenses" },
  { href: "/events", text: "Événements" },
  { href: "/rider/airports", text: "Aéroports" },
  { href: "/gift", text: "Cartes-cadeaux" },
  { href: "/donate", text: "Faire un don" },
];

const footerLyftLinks = [
  { href: "/careers", text: "Carrières" },
  { href: "/lyftup/programs", text: "Metua'aUp" },
  { href: "/business", text: "Entreprises" },
  { href: "/healthcare", text: "Soins de santé" },
  { href: "/bikes", text: "Vélos" },
  { href: "/scooters", text: "Trottinettes" },
  { href: "/autonome", text: "Autonome" },
  { href: "https://ads.lyft.com", text: "Publicités Metua'a" },
  { href: "/lieux-et-evenements", text: "Partenariats avec l'équipe Venue" },
  { href: "/developers", text: "Développeurs" },
  { href: "/blog", text: "Blogue Metua'a" },
  { href: "/press", text: "Médias" },
  { href: "https://investor.lyft.com", text: "Relations avec les investisseurs" },
];

// --- Sous-composants -----------------------------------------------------------

function CarouselCard({ card, index }) {
  const intl = useIntl();

  return (
    <div
      aria-label={intl.formatMessage({ id: card.labelId })}
      role="tabpanel"
      className="sc-1b0948ad-3 hBYsBS"
      style={{ flex: "0 0 auto", marginRight: "8px" }}
    >
      <div className="sc-imWYAI cbwVrP">
        <button
          aria-expanded="false"
          data-testid="card"
          className="sc-17b8964b-0 iRYMxn"
          style={{ width: "212px", minHeight: "256px" }}
        >
          <div className="sc-17b8964b-4 eNpPVj">
            <span data-testid="text" className="sc-bmzYkS jHVFAY">
              {intl.formatMessage({ id: card.titleId })}
            </span>
          </div>
          <div data-testid="core-ui-spacer" className="sc-gsFSXq gnHzMj" />
          <picture data-testid="img-container">
            <img
              src={card.img}
              alt=""
              data-testid="image"
              width={index === 2 || index === 4 ? 72 : 73}
              height={51}
              className="sc-cb728b07-0 bLpAQa sc-17b8964b-1 cALoZb"
            />
          </picture>
          <div data-testid="core-ui-spacer" className="sc-gsFSXq fORnup" />
          <div className="sc-f7dba9ea-2 cuxMbl">
            <div className="sc-f7dba9ea-1 iTmZYN">
              <p data-testid="core-ui-text" className="sc-bmzYkS iKCksV sc-6e64fb35-0">
                <span className="sc-f7dba9ea-0 bizXex">
                  <span data-testid="core-ui-icon" className="sc-jEACwC fWFepk">
                    {card.descIcons[0]}
                  </span>
                </span>
                {intl.formatMessage({ id: card.descTextIds[0] })}
                <br />
                <span className="sc-f7dba9ea-0 bizXex">
                  <span data-testid="core-ui-icon" className="sc-jEACwC fWFepk">
                    {card.descIcons[1]}
                  </span>
                </span>
                {intl.formatMessage({ id: card.descTextIds[1] })}
              </p>
            </div>
          </div>
        </button>
      </div>
    </div>
  );
}

function FooterColumn({ title, links }) {
  return (
    <div className="sc-dOvA-dm gASdYH">
      <div className="sc-eSfNbN gdATaP">
        <h2 data-testid="core-ui-text" className="sc-bmzYkS bmTkUk">{title}</h2>
      </div>
      <button className="sc-bXWnss dAzuYD core-ui-focus">
        <h2 data-testid="core-ui-text" className="sc-bmzYkS bmTkUk">{title}</h2>
        <span data-testid="core-ui-icon" className="sc-jEACwC fWFepk">
          <IconChevronDown />
        </span>
      </button>
      <ul className="sc-fLvQuD kmaTJn">
        {links.map((link, i) => (
          <li key={i} className="sc-cRmqLi fvtyuu">
            <a href={link.href} className="sc-dUWDJJ gtZVmu">
              <span data-testid="core-ui-text" className="sc-bmzYkS kfdjbm">
                {link.text}
              </span>
            </a>
          </li>
        ))}
      </ul>
      <div className="sc-aNeao eSwNsk">
        <div data-testid="core-ui-horizontal-divider" className="sc-iMWBiJ iTMXWV" />
      </div>
    </div>
  );
}


export default function AllRider() {
  const intl = useIntl();
  const t = (id, values) => intl.formatMessage({ id }, values);
  const [activeTier, setActiveTier] = useState(1);
  const navigate = useNavigate();
  const [carouselOffset, setCarouselOffset] = useState(0);
  const cardWidth = 228;
  const maxOffset = (carouselCards.length - 1) * cardWidth;

  const activeCard = rideCards[activeTier];

  return (
    <div id="__next" style={{ zoom: 0.82 }}>
      <div className="sc-19804fb5-0 fKeZVt">
        <span data-testid="core-ui-theme-provider" className="sc-dGCmGc kFXgow">

          {/* -- Skip link -- */}
          <div className="sc-a297abbd-0 hLwNen">
            <span data-testid="core-ui-theme-provider" className="sc-dGCmGc jYRudL sc-63eb72f4-0 dWpSLp">
              <span data-testid="core-ui-button-wrapper" className="sc-eBMEME eHLGuU">
                <button
                  data-testid="core-ui-button"
                  type="button"
                  aria-disabled="false"
                  style={{ "--padding": "16px", "--min-height": "32px", "--min-width": "100px" }}
                  className="sc-dCFHLb sc-tagGq sc-esYiGF dfkCaR krlRAc HOcMb"
                >
                  <span className="sc-gmPhUn kESbtj">
                    <span data-testid="multi-line-text-wrap" className="sc-aXZVg kGRXWn">
                      <span data-testid="icon-button-text" className="sc-bmzYkS cLfdwp">
                        {t("home.skipToMain")}
                      </span>
                    </span>
                  </span>
                </button>
              </span>
            </span>
          </div>

          <span data-testid="core-ui-theme-provider" className="sc-dGCmGc cukWQg">

            {/* ------------------ HEADER ------------------ */}
            <Header /> 
    <main className="all-rider-page">
      <section className="section hero-section">
        <div className="page-shell">
          <div className="split-layout driver-hero-layout">
            <div className="split-copy hero-copy driver-hero-copy">
              <h2 className="driver-enterprise-title">
                {t("driver.hero.title")}
              </h2>
              <input
                type="tel"
                className="driver-phone-input"
                placeholder={t("driver.hero.phone.placeholder")}
                aria-label={t("driver.hero.phone.ariaLabel")}
              />
              <p className="driver-legal-copy">
                {t("driver.hero.legal")}
              </p>
              <button type="button" className="driver-cta" onClick={() => navigate("/signup-driver-v2")}>
                {t("driver.hero.cta")}
              </button>
              <button type="button" className="driver-cta-2" onClick={() => navigate("/mplus-program")}>
                {t("driver.hero.cta2")}
              </button>
              <label className="driver-consent">
                <input type="checkbox" />
                <span>
                  {t("driver.hero.consent.prefix")}<a href="/terms">{t("driver.hero.consent.link")}</a>
                </span>
              </label>
            </div>

            <div className="split-media driver-hero-media">
              <img className="driver-hero-image" src={driverHeroPhoto} alt={t("driver.hero.photo.alt")} loading="eager" decoding="async" />
            </div>
          </div>
        </div>
      </section>
      <DriverStepsSection />

    <section className="section driver-rewards-section">
        <div className="page-shell">
          <div className="split-layout driver-rewards-layout">
            <div className="split-media driver-rewards-media">
              <img
                className="driver-rewards-image"
                src={driverRewardsPhoto}
                alt={t("driver.rewards.photo.alt")}
                loading="lazy"
                decoding="async"
              />
            </div>
            <div className="split-copy driver-rewards-copy">
              <h2 className="driver-enterprise-title">
                <span className="driver-rewards-line">{t("driver.rewards.title1")}</span>
                <span className="driver-rewards-line">{t("driver.rewards.title2")}</span>
                <span className="driver-rewards-line">{t("driver.rewards.title3")}</span>
              </h2>
              <br/>
              
              <p className="section-copy driver-rewards-copy-text">
                {t("driver.rewards.description")}
              </p>
              <div className="section-actions">
                <button type="button" className="driver-rewards-cta" onClick={() => navigate("/driver/rewards")}>
                  {t("driver.rewards.cta")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

    <section className="section section-soft driver-enterprise-section">
        <div className="page-shell">
          <header className="driver-enterprise-header">
            <h2 className="driver-enterprise-title">{t("driver.enterprise.title")}</h2>
            <p className="driver-enterprise-subtitle">
              {t("driver.enterprise.subtitle")}
            </p>
          </header>

          <div className="driver-enterprise-cta-wrap">
            <button type="button" className="driver-enterprise-cta" onClick={() => navigate("/signup-business")}>
              {t("driver.enterprise.cta")}
            </button>
          </div>

          <div className="driver-enterprise-grid" role="list" aria-label={t("driver.enterprise.ariaLabel")}>
            <article className="driver-enterprise-card" role="listitem">
              <span className="driver-enterprise-card-icon">
                <EnterpriseFeatureIcon kind="shield" />
              </span>
              <h3>{t("driver.enterprise.card1.title")}</h3>
              <p>{t("driver.enterprise.card1.description")}</p>
            </article>

            <article className="driver-enterprise-card" role="listitem">
              <span className="driver-enterprise-card-icon">
                <EnterpriseFeatureIcon kind="card" />
              </span>
              <h3>{t("driver.enterprise.card2.title")}</h3>
              <p>{t("driver.enterprise.card2.description")}</p>
            </article>

            <article className="driver-enterprise-card" role="listitem">
              <span className="driver-enterprise-card-icon">
                <EnterpriseFeatureIcon kind="users" />
              </span>
              <h3>{t("driver.enterprise.card3.title")}</h3>
              <p>{t("driver.enterprise.card3.description")}</p>
            </article>

            <article className="driver-enterprise-card" role="listitem">
              <span className="driver-enterprise-card-icon">
                <EnterpriseFeatureIcon kind="chart" />
              </span>
              <h3>{t("driver.enterprise.card4.title")}</h3>
              <p>{t("driver.enterprise.card4.description")}</p>
            </article>
          </div>
        </div>
      </section>

    </main>

    
            {/* ------------------ FOOTER ------------------ */}
            <Footer />
          </span>
        </span>
      </div>
    </div>
  );
}







